import { ArrowDown, ArrowUp } from 'lucide-react';
import { formatDate, formatRelativeDays, type ContactListSort } from '@brimo/shared';
import { Icon } from '../../ds/components';
import { toggleEntrySort } from './list-controls';
import styles from './ContactsPage.module.css';

/** „Eingang“ cell (FB-003, D-320): the entry date and below it the age in Berlin calendar days. */
export function EntryCell({ createdAt, now }: { createdAt: string; now?: Date | undefined }) {
  return (
    <span className={styles.entry}>
      <span className={styles.entryDate}>{formatDate(createdAt)}</span>
      <span className={styles.entryAge}>{formatRelativeDays(createdAt, now)}</span>
    </span>
  );
}

/** Header of „Eingang“: a button that toggles newest/oldest first and shows the active direction. */
export function EntryHeader({
  sort,
  onSort,
}: {
  sort: ContactListSort;
  onSort: (next: ContactListSort) => void;
}) {
  const direction = sort === 'newest' ? 'descending' : sort === 'oldest' ? 'ascending' : 'none';
  return (
    <button
      type="button"
      className={styles.sortHeader}
      title={sort === 'newest' ? 'Älteste zuerst' : 'Neueste zuerst'}
      onClick={() => onSort(toggleEntrySort(sort))}
    >
      Eingang
      {direction !== 'none' ? (
        <Icon icon={direction === 'descending' ? ArrowDown : ArrowUp} size={16} />
      ) : null}
    </button>
  );
}
